import {BENEFICIARY_DRAWER, FIELD_STATUS, FORM_STATUS} from "../status";
import {
    ADD_NEW_TRANSITION_BENEFICIARIES,
    CANCEL_EDIT_OF_TRANSITION_BENEFICIARIES,
    CONTINUE_TRANSITION_BENEFICIARIES,
    DATE_OF_BIRTH_SET_VALID,
    DATE_OF_BIRTH_SET_VALUE,
    DELETE_TRANSITION_BENEFICIARIES,
    EDIT_TRANSITION_BENEFICIARIES,
    EMAIL_SET_VALID,
    EMAIL_SET_VALUE,
    FIRST_NAME_SET_VALID,
    FIRST_NAME_SET_VALUE,
    FORM_INVALID_TRANSITION_BENEFICIARIES,
    FORM_VALID_TRANSITION_BENEFICIARIES,
    GENDER_SET_VALID,
    GENDER_SET_VALUE,
    MOBILE_NUMBER_SET_VALID,
    MOBILE_NUMBER_SET_VALUE,
    SAVE_TRANSITION_BENEFICIARIES,
    SURNAME_SET_VALID,
    SURNAME_SET_VALUE,
    TITLE_SET_VALID,
    TITLE_SET_VALUE,
    TOGGLE_EDIT_TRANSITION_BENEFICIARIES,
    TOGGLE_READ_MORE_TRANSITION_BENEFICIARIES,
    DELETE_BENEFICIARY_POPUP_TRACKING,
    ADD_MORE_THAN_MAX_BENEFICIARIES_TRACKING,
    REMOVE_ID_SET,
    RESET_BENEFICAIRIES
} from "../../actions/raOptimal/beneficiaries";
import {BACK_TRANSITION_BENEFICIARIES_SPLIT} from "../../actions/raOptimal/beneficiariesSplit";

const newBeneficiary = () => ({
    title: {value: null, error: null, status: null},
    firstName: {value: null, error: null, status: null},
    surname: {value: null, error: null, status: null},
    dateOfBirth: {value: null, error: null, status: null},
    gender: {value: null, error: null, status: null},
    mobileNumber: {value: null, error: null, status: null},
    email: {value: null, error: null, status: null},
});
export const newEditBeneficiary = () => ({
    form: newBeneficiary(),
    formStatus: FORM_STATUS.INVALID,
})
export const initBeneficiaries = {
    beneficiaries: [],
    beneficiariesIdIndex: 0,
    showBeneficiarySplitScreen: false,
    openDrawer: null,
    editId: null,
    removeId: null,
    editBeneficiary: newEditBeneficiary(),
    deleteBeneficiaryPopupCount: 0,
    maxBeneficiariesAdded: 0,
};

export default (state = initBeneficiaries, action) => {
    const mapError = error => error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID;
    const updateFormField = (fieldId, update) => ({
        ...state,
        editBeneficiary: {
            ...state.editBeneficiary,
            form: {
                ...state.editBeneficiary.form,
                [fieldId]: update(state.editBeneficiary.form[fieldId]),
            },
        },
    });

    switch (action.type) {
        // Routing
        case CONTINUE_TRANSITION_BENEFICIARIES:
            return state.beneficiaries.length > 1
                ? {...state, showBeneficiarySplitScreen: true}
                : state;
        case BACK_TRANSITION_BENEFICIARIES_SPLIT:
            return {...state, showBeneficiarySplitScreen: false};

        // CRUD operations
        case ADD_NEW_TRANSITION_BENEFICIARIES:
            // replace edit beneficiary with new instance
            return state;
        case DELETE_TRANSITION_BENEFICIARIES:
            // use key to delete beneficiary from list
            const delId = action.beneficiaryId;
            const beneficiaries = state.beneficiaries.filter(ben => ben.id !== delId);
            return {
                ...state,
                beneficiaries,
            };
        case EDIT_TRANSITION_BENEFICIARIES:
            // use key to copy beneficiary from list to edit beneficiary
            const editId = action.beneficiaryId;
            const editForm = state.beneficiaries.find(ben => ben.id === editId);

            if (!editForm)
                return state;

            return {
                ...state,
                editId,
                editBeneficiary: {
                    form: Object.assign({}, editForm.value),
                    formStatus: FORM_STATUS.VALID,
                },
            };
        case CANCEL_EDIT_OF_TRANSITION_BENEFICIARIES:
            // replace edit beneficiary with new instance
            return {
                ...state,
                editId: null,
                editBeneficiary: newEditBeneficiary(),
            };
        case SAVE_TRANSITION_BENEFICIARIES:
            if (state.editBeneficiary.formStatus === FORM_STATUS.INVALID)
                return state;
            /**
             * 1. copy edit beneficiary
             * 2. clear edit beneficiary instance
             * 3. if action.beneficiaryId,
             *      then updating:
             *          find beneficiary in list, and replace with (1)
             *      else adding new beneficiary to list:
             *          copy new ID from and increment beneficiariesIdIndex
             *          append (1) to list with new ID
             **/
            const isNewBeneficiary = action.beneficiaryId == null;
            const beneficiaryId = isNewBeneficiary
                ? state.beneficiariesIdIndex
                : action.beneficiaryId;
            const newBeneficiary = {
                id: beneficiaryId,
                value: state.editBeneficiary.form
            };

            if (isNewBeneficiary) {
                return {
                    ...state,
                    beneficiaries: [...state.beneficiaries, newBeneficiary],
                    beneficiariesIdIndex: state.beneficiariesIdIndex + 1,
                    editBeneficiary: newEditBeneficiary(),
                };
            }

            const prevList = state.beneficiaries;
            const index = prevList.findIndex(ben => ben.id === beneficiaryId)
            const edited = {
                id: beneficiaryId,
                value: state.editBeneficiary.form,
            };
            const newList = [
                ...prevList.slice(0, index),
                edited,
                ...prevList.slice(index + 1)
            ];

            return {
                ...state,
                beneficiaries: newList,
                editId: null,
                editBeneficiary: newEditBeneficiary(),
            };

        // Form Validation
        case FORM_VALID_TRANSITION_BENEFICIARIES:
            return {
                ...state,
                editBeneficiary: {
                    ...state.editBeneficiary,
                    formStatus: FORM_STATUS.VALID,
                },
            };
        case FORM_INVALID_TRANSITION_BENEFICIARIES:
            return {
                ...state,
                editBeneficiary: {
                    ...state.editBeneficiary,
                    formStatus: FORM_STATUS.INVALID,
                },
            };

        // Drawers
        case TOGGLE_READ_MORE_TRANSITION_BENEFICIARIES:
            return {
                ...state,
                openDrawer: state.openDrawer
                    ? null
                    : BENEFICIARY_DRAWER.READ_MORE,
            };
        case TOGGLE_EDIT_TRANSITION_BENEFICIARIES:
            return {
                ...state,
                openDrawer: state.openDrawer
                    ? null
                    : BENEFICIARY_DRAWER.EDIT,
            };

        // Form Fields
        case TITLE_SET_VALUE:
            return updateFormField('title', field => ({
                ...field,
                value: action.value,
            }));
        case TITLE_SET_VALID:
            return updateFormField('title', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', field => ({
                ...field,
                value: action.value,
            }));
        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SURNAME_SET_VALUE:
            return updateFormField('surname', field => ({
                ...field,
                value: action.value,
            }));
        case SURNAME_SET_VALID:
            return updateFormField('surname', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DATE_OF_BIRTH_SET_VALUE:
            return updateFormField('dateOfBirth', field => ({
                ...field,
                value: action.value,
            }));
        case DATE_OF_BIRTH_SET_VALID:
            return updateFormField('dateOfBirth', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case GENDER_SET_VALUE:
            return updateFormField('gender', field => ({
                ...field,
                value: action.value,
            }));
        case GENDER_SET_VALID:
            return updateFormField('gender', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MOBILE_NUMBER_SET_VALUE:
            return updateFormField('mobileNumber', field => ({
                ...field,
                value: action.value,
            }));
        case MOBILE_NUMBER_SET_VALID:
            return updateFormField('mobileNumber', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMAIL_SET_VALUE:
            return updateFormField('email', field => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_SET_VALID:
            return updateFormField('email', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case DELETE_BENEFICIARY_POPUP_TRACKING: 
            return {
                ...state,
                deleteBeneficiaryPopupCount: state.deleteBeneficiaryPopupCount + 1,
            }
        case ADD_MORE_THAN_MAX_BENEFICIARIES_TRACKING: 
            return {
                ...state,
                maxBeneficiariesAdded: state.maxBeneficiariesAdded + 1,
            }

        case REMOVE_ID_SET: 
            return {
                ...state,
                removeId: action.value,
            }
            
        case RESET_BENEFICAIRIES:
            return { ...initBeneficiaries };

        default:
            return state;
    }
};
